// extracted by mini-css-extract-plugin
export default {"container":"YellowTabs_container__qJHxE","tab":"YellowTabs_tab__DoNy0","active":"YellowTabs_active__tjCS1"};